var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 14C1.75 11.5255 1.75 10.2874 2.51912 9.51912C3.28737 8.75 4.5255 8.75 7 8.75H14C16.4745 8.75 17.7126 8.75 18.4809 9.51912C19.25 10.2874 19.25 11.5255 19.25 14C19.25 16.4745 19.25 17.7126 18.4809 18.4809C17.7126 19.25 16.4745 19.25 14 19.25H7C4.5255 19.25 3.28737 19.25 2.51912 18.4809C1.75 17.7126 1.75 16.4745 1.75 14Z",
    stroke: "white",
    strokeWidth: 1.3125
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 8.75V7C5.25 5.60761 5.80312 4.27226 6.78769 3.28769C7.77226 2.30312 9.10761 1.75 10.5 1.75C11.8924 1.75 13.2277 2.30312 14.2123 3.28769C15.1969 4.27226 15.75 5.60761 15.75 7V8.75",
    stroke: "white",
    strokeWidth: 1.3125,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock1);
export default __webpack_public_path__ + "static/media/lock1.b8f54aaec1387f270c99dae9362bf876.svg";
export { ForwardRef as ReactComponent };